import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Organization page now redirects to Settings > Org tab
// All organization management has been consolidated there
const Organization = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/settings?section=room', { replace: true });
  }, [navigate]);

  return null;
};

export default Organization;
